var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-mobile"},[_c('img',{staticClass:"mobile-logo",attrs:{"src":_setup.COMPANY_LOGO,"alt":""}}),_c(_setup.MobileMenu,{ref:"selfMobileRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }